<template>
  <b-form-group class="mb-5" label-cols="4" label-cols-lg="2" label-class="font-weight-bold" :label="label ? label : 'Filter:' " label-for="select-filter">
    <b-form-select
      v-model="value"
      :options="[{ value: '*', text: allLabel ? allLabel : 'All' }].concat(options.map(option => ({ value: option, text: option })))"
      @input="onChange"
    />
  </b-form-group>
</template>

<script>
export default {
  name: 'MioSelect',
  props: {
    value: String,
    label: String,
    allLabel: String,
    options: Array,
  },
  methods: {
    onChange (event) {
      this.$emit('input', event);
    }
  },
}
</script>
